/**
 * Placeholder for the OCPI screen type.
 * To be implemented in a future ticket.
 */
export function OcpiScreen() {
  return (
    <div className="flex h-full items-center justify-center p-8">
      <div className="max-w-md rounded-lg border border-gray-200 bg-gray-50 p-6 text-center">
        <p className="font-medium text-gray-700">OCPI Screen</p>
        <p className="mt-1 text-sm text-gray-500">This screen type is not yet supported.</p>
      </div>
    </div>
  );
}
